export default {"src":"/_next/static/media/alchemistIcon.e74589ed.svg","height":88,"width":77};